function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#00d6ff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "header"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M55.8,31.15c-.83,3.63-3.56,6-8,6h-28c-.65,0-.91-.33-.76-1l.87-4.09a1.09,1.09,0,0,1,1.14-1ZM3.29,20.8H38.06a1.08,1.08,0,0,0,1.13-1l.87-4.08c.15-.62-.11-1-.76-1h-28c-4.48,0-7.2,2.4-8,6M18.2,31.15H2.05a1.07,1.07,0,0,0-1.13,1L0,36.23c-.15.62.11,1,.77,1h9.35c4.48,0,7.21-2.4,8-6M40.86,20.8H57a1.08,1.08,0,0,0,1.13-1L59,15.73c.14-.62-.11-1-.77-1H48.9c-4.48,0-7.21,2.4-8,6m15.51,7.7a4.34,4.34,0,0,0-4.24-5.26H40.39a4.88,4.88,0,0,0,0,.62c0,3,1.89,4.64,5.51,4.64Zm-37.64,0a4.34,4.34,0,0,0-4.24-5.26H2.77a5.15,5.15,0,0,0,0,.62c0,3,1.9,4.64,5.51,4.64Zm18.76-.73.73-3.36c.14-.66-.11-.95-.77-.95H22.65a1,1,0,0,0-1.13.95l-.73,3.36c-.15.65.11.94.77.94H36.35a1,1,0,0,0,1.14-.94"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M87.23,18.92a.43.43,0,0,1,.49.49v2.12a.43.43,0,0,1-.49.49H76.06a1.07,1.07,0,0,0-.91.34,1.39,1.39,0,0,0-.27.91V24c0,.83.39,1.25,1.16,1.25H84.4a4,4,0,0,1,2.92,1,3.89,3.89,0,0,1,1,2.84V30.9a3.66,3.66,0,0,1-1,2.63,4,4,0,0,1-3,1H72c-.34,0-.51-.16-.51-.49V31.92c0-.33.17-.49.51-.49H83.71a1.11,1.11,0,0,0,.91-.33,1.44,1.44,0,0,0,.27-.92v-.91c0-.83-.39-1.25-1.16-1.25H75.37a3.94,3.94,0,0,1-2.92-1,3.85,3.85,0,0,1-1-2.85V22.56a3.64,3.64,0,0,1,1-2.63,4,4,0,0,1,3-1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M120.65,18.92a.44.44,0,0,1,.49.49v8.9a6.75,6.75,0,0,0,.14,1.48,2,2,0,0,0,.48.94,2,2,0,0,0,.91.49,5.7,5.7,0,0,0,1.43.14h9a.43.43,0,0,1,.49.49V34a.43.43,0,0,1-.49.49H124a11.38,11.38,0,0,1-2.88-.31,4.37,4.37,0,0,1-1.92-1,4.06,4.06,0,0,1-1.1-1.83,9.41,9.41,0,0,1-.34-2.73V19.41a.44.44,0,0,1,.51-.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M145.53,18.92a2.72,2.72,0,0,1,1.42.35,3.47,3.47,0,0,1,1.14,1.35L155.47,34a.46.46,0,0,1,.06.36q-.06.15-.33.15h-2.83a.51.51,0,0,1-.51-.29l-1.58-2.88H139.8l-1.54,2.88a.54.54,0,0,1-.51.29h-2.9c-.19,0-.31-.05-.35-.15a.46.46,0,0,1,.06-.36l7.31-13.4A3.81,3.81,0,0,1,143,19.27a2.28,2.28,0,0,1,1.25-.35Zm-4.33,9.86h7.67l-3.54-6.53a.27.27,0,0,0-.25-.16H145a.27.27,0,0,0-.25.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M170.88,18.92a4.67,4.67,0,0,1,3.26.92,3.61,3.61,0,0,1,1,2.76v1.07a3.19,3.19,0,0,1-1.42,2.83,3.09,3.09,0,0,1,1.53,2.88v1.29a5.72,5.72,0,0,1-.2,1.61,2.85,2.85,0,0,1-.66,1.21,2.81,2.81,0,0,1-1.21.77,5.64,5.64,0,0,1-1.87.27H158a.59.59,0,0,1-.66-.67V19.59a.59.59,0,0,1,.66-.67Zm-10.1,6.49h9.14a2.47,2.47,0,0,0,1.51-.33,1.2,1.2,0,0,0,.4-1v-.76a1.26,1.26,0,0,0-.39-1,2,2,0,0,0-1.26-.32h-9.11a.25.25,0,0,0-.29.29Zm0,2.43v3.32c0,.2.09.29.29.29h9.14a2,2,0,0,0,1.27-.32,1.31,1.31,0,0,0,.38-1v-.84a1.29,1.29,0,0,0-.42-1.05,2.36,2.36,0,0,0-1.52-.36Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 98.71,
  y: 5.72,
  width: 2.95,
  height: 14.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 98.71,
  y: 26.4,
  width: 2.95,
  height: 15.45
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 94.18,
  y: 24.92,
  width: 12.02,
  height: 2.95
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 90.71,
  y: 18.95,
  width: 18.95,
  height: 2.95
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 64.95,
  width: 0.37,
  height: 51.96
})));

function SvgSesStlabLogoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 175.22 51.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSesStlabLogoBlue);
export default __webpack_public_path__ + "static/media/ses-stlab-logo-blue.7ba391af.svg";
export { ForwardRef as ReactComponent };